import { allDomains, Site } from '../constants/siteList'
import { isDevelopment } from './envHelper'

// themeforest -> themeforest.net
export const getCurrentSiteDomain = (currentSite: Site) => {
  if (isDevelopment()) {
    return `${currentSite}.test`
  } else {
    return `${currentSite}.net`
  }
}

// themeforest.net -> themeforest
export const getCurrentSiteFromDomain = (domain: string) => domain.split('.')[0]
